/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTabQueryResponse,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTabPathParams,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab400,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab401,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab500,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab } from "../../clients/courseRegistrationEnrollmentController/getApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab.ts";

export const getApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTabQueryKey =
  (
    courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTabPathParams["courseRegistrationId"],
  ) =>
    [
      {
        url: "/api/v1/courseregistration/enrollment/:courseRegistrationId/course-access-tab",
        params: { courseRegistrationId: courseRegistrationId },
      },
    ] as const;

export type GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTabQueryKey =
  ReturnType<
    typeof getApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTabQueryKey
  >;

export function getApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTabQueryOptions(
  courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTabPathParams["courseRegistrationId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTabQueryKey(
      courseRegistrationId,
    );
  return queryOptions<
    GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTabQueryResponse,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab400
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab401
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab500
    >,
    GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTabQueryResponse,
    typeof queryKey
  >({
    enabled: !!courseRegistrationId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab(
        courseRegistrationId,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @description Retorna se o acesso ao curso está liberado, período de liberação e datas de início e fim, para exibição na aba Acesso ao Curso do gerenciamento. **(Requer Authorization para autenticação)**
 * @summary Retorna dados de acesso ao curso de uma matrícula (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/enrollment/:courseRegistrationId/course-access-tab}
 */
export function useGetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab<
  TData =
    GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTabQueryResponse,
  TQueryData =
    GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTabQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTabQueryKey,
>(
  courseRegistrationId: GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTabPathParams["courseRegistrationId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTabQueryResponse,
        ResponseErrorConfig<
          | GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab400
          | GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab401
          | GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTabQueryKey(
      courseRegistrationId,
    );

  const query = useQuery(
    {
      ...getApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTabQueryOptions(
        courseRegistrationId,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab400
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab401
      | GetApiV1CourseregistrationEnrollmentCourseregistrationidCourseAccessTab500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
